<template>
  <div>
    <JuneBanner />
    <v-container>
      <div class="book-types-container">
        <h1 class="text-center book-type-header">
          {{ $t("shop.bookTypes") }}
        </h1>
        <div class="justify-center tags-container">
          <v-btn
            v-for="item in categoryButtons"
            :key="item.code"
            color="secondary"
            depressed
            class="tag text-none white--text"
            elevation="0"
            :to="{
              name: 'browseBySubject',
              params: { code: item.code, name: item.label },
            }"
          >
            {{ item.label }}
            <v-icon
              right
              small
              color="white"
            >
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div
        class="divider-heading d-flex flex-column flex-sm-row justify-content-between align-center justify-space-between pb-1"
      >
        <h1 class="text-sm-left text-center">
          {{ $t("shop.ourSelection") }}
        </h1>
      </div>
      <ApolloQuery
        :query="(gql) => getFeaturedBooksQuery"
        :variables="{ order: [{ position: 'ASC' }] }"
      >
        <template
          #default="{
            result: { error: featuredError, data: featuredData },
            isLoading: featuredLoading,
          }"
        >
          <template v-if="!featuredLoading && hasFeaturedBooks(featuredData)">
            <book-display
              :data="featuredBooksData(featuredData)"
              :is-loading="false"
              :error="featuredError"
              :loading-items="loadingItemsCount"
              :pagination-enabled="false"
            />
          </template>
          <template v-else-if="featuredLoading">
            <book-display
              :data="[]"
              :is-loading="true"
              :loading-items="loadingItemsCount"
            />
          </template>
          <ApolloQuery v-else :query="(gql) => fallbackLocalBooksQuery">
            <template #default="{ result: { error, data }, isLoading, query }">
              <book-display
                :data="data?.localBooks?.collection || []"
                :is-loading="!!isLoading"
                :error="error"
                :query="query"
                :loading-items="loadingItemsCount"
              />
              <empty-book-list
                v-if="
                  !isLoading &&
                  (!data?.localBooks?.collection ||
                    data?.localBooks?.collection?.length === 0)
                "
              />
            </template>
          </ApolloQuery>
        </template>
      </ApolloQuery>
    </v-container>
  </div>
</template>

<script>
import EmptyBookList from "@/components/EmptyBookList";
import BookDisplay from "@/components/BookDisplay";
import gql from "graphql-tag";
import LocalBookFragments from "@/graphql/LocalBookFragments";
import FeaturedBookQueries from "@/graphql/FeaturedBookQueries";
import JuneBanner from "@/components/featuredBookBanners/JuneBanner.vue";

const BgPath = require("@/assets/img/ekitabu-logo-repeating.svg");
export default {
  name: "HomeScreen",
  metaInfo() {
    return {
      title: this.$t("seo.defaultTitle"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("seo.homeDescription"),
        },
      ],
    };
  },
  components: {
    EmptyBookList,
    BookDisplay,
    JuneBanner,
  },
  data() {
    return {
      bg: BgPath,
      categoryButtons: [
        { code: "F", label: this.$t("categories.fiction") },
        { code: "DC", label: this.$t("categories.poetry") },
        { code: "cbe_textbooks", label: this.$t("categories.textBooks") },
        {
          code: "children_young_adult",
          label: this.$t("categories.childrenYoungAdult"),
        },
        { code: "best_sellers", label: this.$t("categories.bestSellers") },
        { code: "DN", label: this.$t("categories.nonFiction") },
      ],
      loadingItemsCount: 12,
    };
  },
  computed: {
    getFeaturedBooksQuery() {
      return FeaturedBookQueries.getFeaturedBooks;
    },
    fallbackLocalBooksQuery() {
      return gql`
        query localBooks($page: Int) {
          localBooks(page: $page) {
            collection {
              ...LocalBookCore
            }
          }
        }
        ${LocalBookFragments.localBookCoreFragment}
      `;
    },
  },
  methods: {
    featuredBooksData(data) {
      return (data?.featuredBooks || []).map((fb) => fb.book);
    },
    hasFeaturedBooks(data) {
      return data?.featuredBooks?.length > 0;
    },
  },
};
</script>

<style scoped>
.book-types-container {
  margin-bottom: 42px;
  box-sizing: border-box;
  padding: 0;
}

.book-types-container .col {
  flex-grow: revert;
}

.product-sort-filter-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.book-type-header {
  font-size: 1.375rem;
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 30px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
}

.tag {
  margin: 8px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem !important;
}

@media screen and (max-width: 899px) {
  .tag {
    margin: 6px;
  }
}

@media screen and (max-width: 599px) {
  .tag {
    margin: 6px 4px;
    width: 100%;
  }

  .tags-container {
    flex-direction: column;
  }

  .book-type-header {
    padding-bottom: 10px;
  }

  .product-sort-filter-container {
    justify-content: center;
  }
}
</style>
